import {
  Row,
  Col,
  Heading,
  Stack,
  Button,
  Container
} from '@leroy-merlin-br/backyard-react-ui'

import { useResize } from 'reactUtils/hooks/use-resize'

import * as S from './styled'

const Error500 = () => {
  const [isMobile] = useResize()

  return (
    <S.Content>
      <Container>
        <Row align="center" reverse="mega" justify="space-between">
          <Col size={{ giga: 5 }}>
            <S.Image
              src={`${window &&
                window.env.assetHost}assets/images/general/500-error.svg`}
              alt="Imagem ilustrativa indicando um erro no servidor"
            />
          </Col>

          <Col size={{ giga: 5 }}>
            <Stack spacing="giga">
              <Heading size="exa" noMargin>
                Imprevistos acontecem...
              </Heading>
              <Stack spacing="zetta">
                <S.SubTitle size="mega">
                  Até as melhores casas precisam de manutenção às vezes. Estamos
                  trabalhando para consertar isso o mais rápido possível.
                  Provavelmente em alguns minutos já estaremos funcionando
                  normalmente.
                </S.SubTitle>

                <Button isStretch={isMobile} href="/" size="mega">
                  Voltar para a Home
                </Button>
              </Stack>
            </Stack>
          </Col>
        </Row>
      </Container>
    </S.Content>
  )
}

export default Error500
